import React, {useState} from 'react';
import {Link} from 'react-router-dom';

import './oldcard.styles.css';


const OldCard = props => {

  
    return(
        <React.Fragment>                         
      <div className="oldcard" >
        <div className="oldcard__header">
            <div className="oldcard__picture">
              <div className="oldcard__picture-overlay">&nbsp;</div>
                <img className="oldcard__picture-img" src={props.image}  alt={props.naslov}/>
            </div>
            <h4 className="card__heading oldcard__heading">
                                    <span className="card__heading-span card__heading-span--2">{props.naslov}</span>
                                </h4>
        </div>
        <div className="oldcard__details">
            <div className="oldcard__data"> 
            <i className="najave-font icofont-direction-sign"></i>             
                <span>{props.duzina}km</span>
            </div>
            <div className="oldcard__data">
            <i className="najave-font icofont-ui-calendar"></i>
                <span> { (new Date(props.datum)).toLocaleDateString('en-GB') }</span>
            </div>
            <div className="oldcard__data"> 
            <i className="najave-font icofont-hill"></i>              
                <span>{props.visina}nvm</span>
            </div>
            <div className="oldcard__data"> 
            <i className="najave-font icofont-compass"></i>              
                <span>{props.kategorija}</span>
            </div> 
        </div>           
        <div className="oldcard__footer">
            <p className="footer-part">
                <span className="oldcard__footer-value"><i className="najave-font icofont-money"></i> {props.cena} din</span>   
                <span className="oldcard__footer-text"><i className="najave-font icofont-chart-histogram"></i>{props.tezina}</span>             
            </p>
           
            <Link to={`najave/${props.id}`}  className="btn btn--green btn--small btn-oldcard" >Detalji</Link>
        </div>
    </div>  
              
          
    </React.Fragment>  
    )
};


export default OldCard;